import { render, staticRenderFns } from "./BuffeloDetails.vue?vue&type=template&id=84a56d4c&"
import script from "./BuffeloDetails.vue?vue&type=script&lang=js&"
export * from "./BuffeloDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports